import React from 'react';
import './about.css';
import Reveal from '../Reveal/Reveal';
import { profile } from '../../data/profile';

function About() {
  return (
    <section className="section section--alt" id="about">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-eyebrow">About</span>
          <h2 className="section-title">A bit about me</h2>
        </Reveal>

        <div className="about-grid">
          <Reveal as="p" className="about-summary" delay={80}>
            {profile.summary}
          </Reveal>

          <ul className="about-facts">
            {profile.facts.map(({ label, value }, index) => (
              <Reveal
                as="li"
                key={label}
                className="card about-fact"
                delay={120 + index * 70}
              >
                <span className="about-fact-label">{label}</span>
                <span className="about-fact-value">{value}</span>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default About;
